import CustomTree from './CustomTree.vue';

export default CustomTree;
